
import { computed, ref } from 'vue'
import Panzoom from '@panzoom/panzoom'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },

    showModal: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const galleryModal = ref()
    const lightboxImage = ref()
    const closeBtn = ref()
    const modalOpen = ref(false)
    const isZoomedOrPanned = ref(false)

    const size = computed(() => props.data.image_size?.value)

    const bodyClasses = computed(() => {
      return modalOpen.value ? 'overflow-hidden' : ''
    })

    const pinchIconClasses = computed(() => {
      return isZoomedOrPanned.value ? 'hidden' : 'block md:hidden'
    })

    function toggleModal(value) {
      const panzoom = Panzoom(lightboxImage?.value, {
        maxScale: 5,
        minScale: 1,
        contain: 'outside',
      })

      if (value) {
        galleryModal?.value?.showModal()
        modalOpen.value = true

        if (window.innerWidth < 1024) {
          panzoom.pan(0, 0)

          panzoom.zoom(1, {
            animate: true,
          })

          lightboxImage.value.addEventListener('panzoomchange', (event) => {
            handlePanzoomChange(event)
          })
        }
      } else {
        galleryModal?.value?.close()
        modalOpen.value = false

        lightboxImage.value.removeEventListener('panzoomchange', (event) => {
          handlePanzoomChange(event)
        })

        panzoom.destroy()

        emit('close-modal')
      }
    }

    const handlePanzoomChange = (event) => {
      isZoomedOrPanned.value = event.detail.scale > 1
    }

    return {
      galleryModal,
      lightboxImage,
      closeBtn,
      pinchIconClasses,
      isZoomedOrPanned,
      modalOpen,
      size,
      bodyClasses,
      toggleModal,
    }
  },

  head() {
    return {
      bodyAttrs: {
        class: [this.bodyClasses],
      },
    }
  },

  watch: {
    showModal: {
      deep: true,
      handler(val) {
        this.toggleModal(val)
      },
    },
  },
}
